import { Brand } from '@/constants/brand';

export function formatPageTitle(pageTitle) {
  return pageTitle ? `${pageTitle} | ${Brand.name}` : `${Brand.name} | ${Brand.tagline}`;
}